import React from "react";
import { Popup, Segment, Menu, Input, Icon } from "semantic-ui-react";

import VendorLocations from "./locations";

function Vendors() {

    const [searchInput, setSearchInput] = React.useState<string | null>('');
    const [searchString, setSearchString] = React.useState<string | null>('');

    const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(e.target.value)
    };

    const onSearch = () => {
        setSearchString(searchInput)
    };


    return (
        <div>
            <Menu pointing>
                <Menu.Item
                    key='Locations'
                    name='locations'
                />
                <Menu.Menu key='member props' position='right'>
                    <Menu.Item key='search'>
                        <Popup
                            content="Enter Zip Code and Click Search Icon"
                            trigger={
                                <Input icon={<Icon size="large" name='search' color="blue" link onClick={onSearch} />} onChange={onSearchInputChange} placeholder='Search All...' />
                            }
                        />
                    </Menu.Item>
                </Menu.Menu>
            </Menu>
            <Segment>
                <VendorLocations zipCode={searchString} />
            </Segment>
        </div >
    )
};

export default Vendors;



